import accessReducer from "./reducers/accessReducer";
import clientReducer from "./reducers/clientReducer";
import { combineReducers } from "redux";
import contactReducer from "./reducers/contactReducer";
import errorsReducer from "./reducers/errorsReducer";
import groupReducer from "./reducers/groupReducer";
import jobFinessReducer from "./reducers/jobFinessReducer";
import keycloakReducer from "./reducers/keycloakReducer";
import licenceReducer from "./reducers/licenceReducer";
import logsReducer from "./reducers/logsReducer";
import moduleReducer from "./reducers/moduleReducer";
import serverReducer from "./reducers/serverReducer";
import statsReducer from "./reducers/statsReducer";
import strategyReducer from "./reducers/strategyReducer";
import userReducer from "./reducers/userReducer";
import vagueReducer from "./reducers/vagueReducer";

const rootReducer = combineReducers({
  logs: logsReducer,
  errors: errorsReducer,
  keycloak: keycloakReducer,
  stats: statsReducer,
  clients: clientReducer,
  servers: serverReducer,
  vagues: vagueReducer,
  groups: groupReducer,
  licences: licenceReducer,
  modules: moduleReducer,
  strategies: strategyReducer,
  jobFiness: jobFinessReducer,
  users: userReducer,
  access: accessReducer,
  contacts: contactReducer,
});

export default rootReducer;
